var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "debug" }, [
    _c("h2", [_vm._v("调试页面")]),
    _vm._v(" "),
    _c("button", { on: { click: _vm.hvhlshalefs } }, [_vm._v("我是按钮")]),
    _vm._v(" "),
    _c("button", { on: { click: _vm.hvalsefvase } }, [_vm._v("debug")]),
    _vm._v(" "),
    _c("button", { on: { click: _vm.xhfaxhfaefae } }, [
      _vm._v("删除自己人的动态")
    ]),
    _vm._v(" "),
    _c("button", { on: { click: _vm.dhxefsef } }, [
      _vm._v("更新周边新房二手房")
    ]),
    _vm._v(" "),
    _c("button", { on: { click: _vm.momentFail } }, [_vm._v("加积分失败")]),
    _vm._v(" "),
    _c("button", { on: { click: _vm.findFakeInvite } }, [
      _vm._v("查看刷分情况")
    ]),
    _vm._v(" "),
    _c("input", {
      attrs: { type: "text", placeholder: "更新意向登记" },
      on: {
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.setRegister.apply(null, arguments)
        }
      }
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.sell_id,
          expression: "sell_id"
        }
      ],
      attrs: { type: "text", placeholder: "更新意向登记id" },
      domProps: { value: _vm.sell_id },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.sell_id = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c("input", {
      attrs: { type: "text", placeholder: "更新摇号结果" },
      on: {
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.setRandom.apply(null, arguments)
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "normal" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.client,
            expression: "client"
          }
        ],
        attrs: { type: "text", placeholder: "客户端" },
        domProps: { value: _vm.client },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.client = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.userName,
            expression: "userName"
          }
        ],
        attrs: { type: "text", placeholder: "账号" },
        domProps: { value: _vm.userName },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.userName = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.passwd,
            expression: "passwd"
          }
        ],
        attrs: { type: "text", placeholder: "密码" },
        domProps: { value: _vm.passwd },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.passwd = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.fullName,
            expression: "fullName"
          }
        ],
        attrs: { type: "text", placeholder: "真实姓名" },
        domProps: { value: _vm.fullName },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.fullName = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.userType,
            expression: "userType"
          }
        ],
        attrs: { type: "text", placeholder: "身份" },
        domProps: { value: _vm.userType },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.userType = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.group,
            expression: "group"
          }
        ],
        attrs: { type: "text", placeholder: "群组" },
        domProps: { value: _vm.group },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.group = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.userCity,
            expression: "userCity"
          }
        ],
        attrs: { type: "text", placeholder: "城市" },
        domProps: { value: _vm.userCity },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.userCity = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.phone,
            expression: "phone"
          }
        ],
        attrs: { type: "text", placeholder: "电话" },
        domProps: { value: _vm.phone },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.phone = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.phonex,
            expression: "phonex"
          }
        ],
        attrs: { type: "text", placeholder: "虚拟号" },
        domProps: { value: _vm.phonex },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.phonex = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.mp_uid,
            expression: "mp_uid"
          }
        ],
        attrs: { type: "text", placeholder: "小程序id" },
        domProps: { value: _vm.mp_uid },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.mp_uid = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.project,
            expression: "project"
          }
        ],
        attrs: { type: "text", placeholder: "开发项目" },
        domProps: { value: _vm.project },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.project = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("button", { on: { click: _vm.addManageUser } }, [_vm._v("添加")])
    ]),
    _vm._v(" "),
    _vm.sales.length > 0
      ? _c(
          "div",
          { staticClass: "sales" },
          _vm._l(_vm.sales, function(sale, index) {
            return _c("div", { key: index, staticClass: "sale" }, [
              _c("img", {
                attrs: {
                  src: sale.head_url,
                  preview: "3",
                  "preview-text": sale.user_name
                }
              }),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(sale.user_name))]),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(sale.real_estate_name))]),
              _vm._v(" "),
              _c("div", [_c("span", [_vm._v("关注数:" + _vm._s(sale.gz))])])
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.backUsers.length
      ? _c(
          "div",
          { staticStyle: { padding: "0 50px" } },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.backUsers, border: "", stripe: "" } },
              [
                _c("el-table-column", { attrs: { prop: "id", label: "id" } }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "name", label: "姓名" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "userName", label: "账号" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "city", label: "城市" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "group", label: "小队" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "userType", label: "身份" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "passwd", label: "密码" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "project", label: "开发项目" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "mp_uid", label: "小程序id" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "phone", label: "电话" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "phonex", label: "虚拟号" }
                })
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bcde1ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bcde1ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/debug.vue
// module id = null
// module chunks = 